import { Divider, Grid, Theme, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { FC } from 'react';
import clsx from 'clsx';

export interface IPageTitleProps {
  title: string;
  showDivider?: boolean;
  additionalHeaderContent?: JSX.Element;
  subTitle?: string | JSX.Element;
  marginBottom?: boolean;
  additionalHeaderContentClass?: string;
  justifyContent?: 'center' | 'flex-start' | 'flex-end';
  flexDirection?: 'row' | 'column';
}

export const PageTitle: FC<IPageTitleProps> = ({
  title,
  showDivider = true,
  additionalHeaderContent,
  marginBottom = true,
  subTitle,
  additionalHeaderContentClass,
  justifyContent = 'center',
  flexDirection = 'column'
}) => {
  const classes = useStyles({ marginBottom, justifyContent, flexDirection });
  return (
    <>
      <Grid container alignItems="center" className={classes.topWrapper}>
        <Typography variant="h1" className={classes.heading}>
          {title}
          <Typography className={classes.subTitle} component="span">
            {subTitle}
          </Typography>
        </Typography>

        <div className={clsx(classes.additionalItems, additionalHeaderContentClass)}>
          {additionalHeaderContent}
        </div>
      </Grid>
      {showDivider && title && <Divider className={classes.divider} />}
    </>
  );
};

const useStyles = makeStyles<
  Theme,
  { marginBottom: boolean; justifyContent: string; flexDirection: string }
>(theme => ({
  heading: {
    lineHeight: 1.2,
    marginBottom: ({ marginBottom }) => (marginBottom ? theme.spacing(0.5) : 0),
    color: theme.palette.primary.main,
    fontSize: 24,
    [theme.breakpoints.up('sm')]: {
      fontSize: 36
    }
  },
  topWrapper: {
    [theme.breakpoints.down('sm')]: {
      justifyContent: ({ justifyContent }) => justifyContent,
      flexDirection: ({ flexDirection }) => flexDirection
    },
    [theme.breakpoints.up('sm')]: {
      marginBottom: theme.spacing(0.5),
      justifyContent: 'flex-start',
      flexDirection: 'row'
    }
  },
  divider: {
    marginBottom: theme.spacing(1)
  },
  additionalItems: {
    [theme.breakpoints.up('sm')]: {
      marginLeft: 'auto'
    }
  },
  subTitle: {
    display: 'block',
    color: '#000',
    marginTop: 5,
    fontSize: '.85rem',
    [theme.breakpoints.up('sm')]: {
      fontSize: '1rem'
    }
  }
}));
